import React from 'react'
import { Link } from 'react-router-dom'
import {
  formatStat,
} from '../../shared'
import { Cell } from '../../components'
import * as routes from '../../routes'

const AdminHashtagCell = ({hashtag, noline, children}) =>
  <Cell noline={noline}>
    <Cell.Image src={hashtag.images && hashtag.images['400']} alt='' large />
    <Cell.Body>
      <Cell.Line>
        <Cell.LineTitle>
          <Link to={routes.dynamic(routes.adminHashtagEditPath, hashtag.id)}>#{hashtag.id}</Link>
        </Cell.LineTitle>
      </Cell.Line>

      {<Cell.Line>
        <Cell.ItemCount>{formatStat(hashtag.count)}</Cell.ItemCount>
      </Cell.Line>}
    </Cell.Body>

    {children}
  </Cell>

export default AdminHashtagCell
